/**
 * @flow
 * @relayHash 3412063f8a595111b40b6e2cb952fdf1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SbSharedFollowSearchProvider_user$ref = any;
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type SbSharedFollowSearchProviderRefetchQueryVariables = {|
  followSearchPages?: ?$ReadOnlyArray<?string>,
  userId?: ?string,
  followSearchTypes?: ?$ReadOnlyArray<?types>,
|};
export type SbSharedFollowSearchProviderRefetchQueryResponse = {|
  +viewer: ?{|
    +user: ?{|
      +$fragmentRefs: SbSharedFollowSearchProvider_user$ref
    |}
  |}
|};
export type SbSharedFollowSearchProviderRefetchQuery = {|
  variables: SbSharedFollowSearchProviderRefetchQueryVariables,
  response: SbSharedFollowSearchProviderRefetchQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "followSearchPages",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "followSearchTypes",
    "type": "[types]",
    "defaultValue": [
      "SEARCH"
    ]
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SbSharedFollowSearchProviderRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "SbSharedFollowSearchProvider_user",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SbSharedFollowSearchProviderRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "favorites",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1,
                    "type": "Int"
                  },
                  {
                    "kind": "Variable",
                    "name": "pages",
                    "variableName": "followSearchPages",
                    "type": "[String]"
                  },
                  {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "followSearchTypes",
                    "type": "[types]"
                  }
                ],
                "concreteType": "favoritesConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "favoritesEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Favorite",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "serviceId",
                            "args": null,
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v2/*: any*/)
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SbSharedFollowSearchProviderRefetchQuery",
    "id": "app-buyer-finding/209.0.0-2019-03-27T14:13:29.601Z/SbSharedFollowSearchProviderRefetchQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd72f0960c456b5e033153f82c76d24a1';
module.exports = node;
